import { NgTraditional } from '@editor2/types/ngTraditional';
import { BookResolver } from '../book/baseResolver';
import { ChapterResolver } from '../chapter/baseResolver';
import { PageGroupResolver } from '../pageGroup/baseResolver';
import { PageResolver } from '../page/baseResolver';
import { ElementConfigName } from '@editor2/types/pageElements';
import { ElementResolver } from '../element/baseResolver';

export const getEntityResolver = (type: NgTraditional) => {
	switch (true) {
		case type === NgTraditional.Book: {
			return new BookResolver();
		}

		case type === NgTraditional.Chapter: {
			return new ChapterResolver();
		}

		case type === NgTraditional.PageGroup: {
			return new PageGroupResolver();
		}

		case type === NgTraditional.Page: {
			return new PageResolver();
		}

		case !!ElementConfigName[type]: {
			return new ElementResolver();
		}

		default:
			break;
	}
};
